import linkify from 'linkify-html'

import { sanitizeWithLinks } from './helpers'
import styles from './styles.module.scss'
import { HtmlTextProps } from './types'

export const HtmlText = ({ body }: HtmlTextProps) => {
  if (!body) {
    return ''
  }

  const decodedHtml = document.createElement('textarea')
  decodedHtml.innerHTML = String(body)

  const content = linkify(sanitizeWithLinks(decodedHtml.value), {
    className: styles.link,
    attributes: {
      target: '_blank',
    },
  })

  return <span dangerouslySetInnerHTML={{ __html: content }} />
}
